import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import * as R from 'ramda';
import { Link } from "react-router-dom";

import { ConnectionTypes, CommonServices, PersonalServices, AuxiliarOptions, OtherService, convertBackEndServiceTypesToFrontEndServiceType } from '../../../../constants/utils/connectionTypes';

import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

import { ModalValidation } from './../_common/modalValidation';
import { ModalCommencer } from './../_common/modalCommencer';
import { DashboardCard } from './dashboardCard';
import { ServicesEdit } from '../_common/serviceEdit';

export const DossierDashboard = ({ serviceDatas, userLetters, files, userId, deathDate, isLoading, connectionTypes, declaringUserId, currentlyConnectedUserId, deceasedUser, generateLetters }) => {
	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();

	}, []);

	const [isLoadingLetters, setIsLoadingLetter] = useState([]);
	const [popupText, setPopupText] = useState({ text: "", lastShownPopup: 0 });
	const [selectedService, setSelectedService] = useState(undefined);
	const [orderBy, setOrderBy] = useState("mostRecent");
	const [searchFilter, setSearchFilter] = useState("");
	const [tilesValues, setTilesValues] = useState({
		in7Days: { total: [], toBeHandled: [] },
		in30Days: { total: [], toBeHandled: [] },
		in6Months: { total: [], toBeHandled: [] }
	});

	//We should get it from backend!
	function service(title, icon, progress, sendingLimitDate, mostRecentDate, serviceDatas, hasBeenValidated) { return { title: title, icon: icon, sendingLimitDate: sendingLimitDate, mostRecentDate: mostRecentDate, progress: (progress === undefined ? 0 : progress), serviceDatas: serviceDatas, hasBeenValidated: hasBeenValidated }; };


	const [userServices, setUserServices] = useState([]);

	const dateIn7Days = new Date(deathDate);
	dateIn7Days.setDate(dateIn7Days.getDate() + 8);

	const dateIn30Days = new Date(deathDate);
	dateIn30Days.setDate(dateIn30Days.getDate() + 31);

	const dateIn6Months = new Date(deathDate);
	dateIn6Months.setMonth(dateIn6Months.getMonth() + 6);

	useEffect(() => {
		const allServices = Object.values(PersonalServices).concat(Object.values(AuxiliarOptions)).concat(Object.values(CommonServices)).concat(Object.values(OtherService));
		let services = [];
		serviceDatas.map((serviceData) => {
			let connectionType = convertBackEndServiceTypesToFrontEndServiceType(serviceData.serviceType);

			let appService = allServices.find(obj => obj.connectionType === connectionType);


			const s = services.find(s => s.title === appService.title);

			const lettersForService = userLetters.filter(l => l.userServiceId === serviceData.id);
			const hasBeenValidated = lettersForService.find(l => l.letterProgressStage === "Created") === undefined;

			if (!R.isNil(appService) && R.isNil(s)) {
				let mostRecentDate = "";

				if (!R.isEmpty(lettersForService)) {
					lettersForService.sort((a, b) => a.sendingLimitDate < b.sendingLimitDate ? -1 : a.sendingLimitDate > b.sendingLimitDate ? 1 : 0);
					mostRecentDate = lettersForService[0].sendingLimitDate;
					if (lettersForService[0].letterProgressStage !== "Created") {
						mostRecentDate = lettersForService[0].letterHistory.find(l => l.letterProgressStage === "Validated" || l.letterProgressStage === "Abandonned").date;
					}

					services.push(service(appService.title, appService.icon, 0, lettersForService[0].sendingLimitDate, mostRecentDate, [serviceData], hasBeenValidated));
				}
			} else {
				if (s.hasBeenValidated === true && hasBeenValidated === false) {
					s.hasBeenValidated = hasBeenValidated;
					s.mostRecentDate = lettersForService[0].sendingLimitDate;
				}

				s.serviceDatas.push(serviceData);
			}

		});
		if (orderBy === "mostRecent") {
			services.sort((a, b) => a.sendingLimitDate < b.sendingLimitDate ? -1 : a.sendingLimitDate > b.sendingLimitDate ? 1 : 0);
		} else {
			services.sort((a, b) => a.title < b.title ? -1 : a.title > b.title ? 1 : 0);
		}

		// if(searchFilter !== ""){
		// 	services = services.filter(s => s.title.toLowerCase().indexOf(searchFilter.toLowerCase()) > -1);
		// }
		setUserServices(services);




	}, [serviceDatas, orderBy, searchFilter, userLetters]);

	useEffect(() => {
		if (userServices.length === 0)
			return;

		if (userServices.every(s => s.hasBeenValidated === false)) {
			setPopupText({ text: "Vous avez trois sections de délai, vous devez commencer par valider les courriers à transmettre dans les 7 jours.", lastShownPopup: 1 });
			if (popupText.lastShownPopup < 1)
				$('#commencerReferent').modal('show');
		}
		if (userServices.filter(s => s.hasBeenValidated === true).length === 1) {
			if(deceasedUser.hasDocumentSending){
				setPopupText({ text: "Vous pouvez suivre vos courriers envoyés en recommandé en cliquant sur les cases validées.", lastShownPopup: 2 });
			}else{
				setPopupText({ text: "Vous pouvez télécharger vos courriers à envoyer en cliquant sur les cases validées.", lastShownPopup: 2 });
			}
			if (popupText.lastShownPopup < 2)
				$('#commencerReferent').modal('show');
		}

		if (userServices.filter(s => new Date(s.sendingLimitDate) <= dateIn7Days && s.hasBeenValidated === true).length === 4) {
			setPopupText({ text: "INFO : Vous avez un espace bibliothèque mis à disposition qui vous permet de transmettre tous les documents que vous aurez sélectionné de façon simple et sécurisée à vos interlocuteurs (membre de la famille, notaire…).", lastShownPopup: 3 });
			if (popupText.lastShownPopup < 3)
				$('#commencerReferent').modal('show');
		}

		if (userServices.filter(s => new Date(s.sendingLimitDate) <= dateIn7Days).every(s => s.hasBeenValidated === true) &&
			userServices.filter(s => new Date(s.sendingLimitDate) > dateIn7Days).every(s => s.hasBeenValidated === false)) {
			setPopupText({ text: "Bravo! Tous les courriers devant être transmis aux organismes dans les 7 jours ont été validés. Veuillez maintenant valider les démarches à faire dans les 30 jours.", lastShownPopup: 4 });
			if (popupText.lastShownPopup < 4)
				$('#commencerReferent').modal('show');
		}
		if (userServices.filter(s => new Date(s.sendingLimitDate) <= dateIn30Days).every(s => s.hasBeenValidated === true) &&
			userServices.filter(s => new Date(s.sendingLimitDate) > dateIn6Months).every(s => s.hasBeenValidated === false)) {
			setPopupText({ text: "Vous avez validé la section de documents à envoyer dans les 30 jours. Enfin, pour terminer les démarches, vous devez valider les courriers à faire dans les 6 mois.", lastShownPopup: 5 });
			if (popupText.lastShownPopup < 5)
				$('#commencerReferent').modal('show');
		}

		if (userServices.length > 0 && userServices.every(s => s.hasBeenValidated === true)) {
			setPopupText({ text: "Votre dossier d’accompagnement dans les démarches administratives est finalisé, il reste disponible pour vous et vos proches pendant 1 an ainsi que tous les documents dans l’espace bibliothèque.", lastShownPopup: 6 });
			if (popupText.lastShownPopup < 6)
				$('#commencerReferent').modal('show');
		}
		const servicesToDisplay = userServices.filter(s => s.title.toLowerCase().indexOf(searchFilter.toLowerCase()) > -1);

		const in7Days = { total: [], toBeHandled: [] };
		const in30Days = { total: [], toBeHandled: [] };
		const in6Months = { total: [], toBeHandled: [] };

		in7Days.total = servicesToDisplay.filter(s => new Date(s.sendingLimitDate) <= dateIn7Days);
		in7Days.toBeHandled = in7Days.total.filter(s => s.hasBeenValidated === false);

		in30Days.total = servicesToDisplay.filter(s => new Date(s.sendingLimitDate) <= dateIn30Days && new Date(s.sendingLimitDate) > dateIn7Days);
		in30Days.toBeHandled = in30Days.total.filter(u => u.hasBeenValidated === false);

		in6Months.total = servicesToDisplay.filter(s => new Date(s.sendingLimitDate) <= dateIn6Months && new Date(s.sendingLimitDate) > dateIn30Days);
		in6Months.toBeHandled = in6Months.total.filter(u => u.hasBeenValidated === false);

		setTilesValues({
			in7Days: in7Days,
			in30Days: in30Days,
			in6Months: in6Months
		});
	}, [userServices]);




	const servicesToHandle = [tilesValues.in7Days.toBeHandled.length, tilesValues.in30Days.toBeHandled.length, tilesValues.in6Months.toBeHandled.length].reduce((a, b) => a + b, 0);
	const servicesTotal = [tilesValues.in7Days.total.length, tilesValues.in30Days.total.length, tilesValues.in6Months.total.length].reduce((a, b) => a + b, 0);

	const servicesToDisplay = userServices.filter(s => s.title.toLowerCase().indexOf(searchFilter.toLowerCase()) > -1);

	return (
		<article className="view-calc pt-4 mb-auto">
			<div className="container-fluid">
				{/* <header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 mb-4">
					<h2 className="sr-only visually-hidden">Status</h2>
					<div className="card shadow rounded">
						<div className="card-header pt-3 pb-0 text-center">
							<p className="h5 o-40 text-uppercase font-weight-bolder m-auto">différentes actions effectuées par Assist@</p>
						</div>
						<div className="card-body stepper">
							<ul className="nav stepper-nav">
								<li className="stepper-item completed">
									<span className="stepper-icon">1</span>
									<span className="stepper-title">Compte créé</span>
								</li>
								<li className="stepper-item completed">
									<span className="stepper-icon">2</span>
									<span className="stepper-title">Documents générés</span>
								</li>
								<li className="stepper-item active">
									<span className="stepper-icon">3</span>
									<span className="stepper-title">Décès de Catwoman</span>
								</li>
								<li className="stepper-item">
									<span className="stepper-icon">4</span>
									<span className="stepper-title">Notification Notaire</span>
								</li>
								<li className="stepper-item">
									<span className="stepper-icon">5</span>
									<span className="stepper-title">Notification Notaire</span>
								</li>
								<li className="stepper-item">
									<span className="stepper-icon">6</span>
									<span className="stepper-title">Notification d'entité</span>
								</li>
								<li className="stepper-item">
									<span className="stepper-icon">7</span>
									<span className="stepper-title">Notification d'entité</span>
								</li>
								<li className="stepper-item">
									<span className="stepper-icon">8</span>
									<span className="stepper-title">Notification d'entité</span>
								</li>
								<li className="stepper-item">
									<span className="stepper-icon">9</span>
									<span className="stepper-title">Notification d'entité</span>
								</li>
								<li className="stepper-item">
									<span className="stepper-icon">10</span>
									<span className="stepper-title">Notification d'entité</span>
								</li>
								<li className="stepper-item">
									<span className="stepper-icon">11</span>
									<span className="stepper-title">Notification d'entité</span>
								</li>
								<li className="stepper-item">
									<span className="stepper-icon">12</span>
									<span className="stepper-title">Notification d'entité</span>
								</li>
							</ul>
						</div>
					</div>
				</header> */}
				<header className="rounded-bottom-left-sm rounded-top-right-sm mb-2">
					<h2 className="sr-only visually-hidden">Status</h2>
					{/* <p className="h5 text-uppercase font-weight-bolder mb-3">différentes actions effectuées par Assist@</p> */}
					<div className="grid grid-sm-narrow grid-lg-base grid-xl-auto grid-hd-4">
						<div className="block">
							<div className="media">
								<div className="media-progress mr-3">
									<CircularProgressbar
										value={tilesValues.in7Days.total.length === tilesValues.in7Days.toBeHandled.length ? 0 : (tilesValues.in7Days.total.length - tilesValues.in7Days.toBeHandled.length) / tilesValues.in7Days.total.length}
										minValue={0}
										maxValue={1}
										background={true}
										styles={buildStyles({
											backgroundColor: "#00000011",
										})}
										text={tilesValues.in7Days.total.length === tilesValues.in7Days.toBeHandled.length ? "0" : (tilesValues.in7Days.total.length - tilesValues.in7Days.toBeHandled.length).toString()}
									/>
								</div>
								<div className="media-body my-auto text-truncate">
									<h3 className="h5 fs-xl-auto fs-hd-root o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">À envoyer sous 7 jours</h3>
									<p className="h3 text-dark font-weight-bolder lh-solid mb-0">{tilesValues.in7Days.toBeHandled.length === 0 ? "Fait" : tilesValues.in7Days.toBeHandled.length}</p>
								</div>
							</div>
						</div>
						<div className="block">
							<div className="media">
								<div className="media-progress mr-3">
									<CircularProgressbar
										value={tilesValues.in30Days.total.length === tilesValues.in30Days.toBeHandled.length ? 0 : (tilesValues.in30Days.total.length - tilesValues.in30Days.toBeHandled.length) / tilesValues.in30Days.total.length}
										minValue={0}
										maxValue={1}
										background={true}
										styles={buildStyles({
											backgroundColor: "#00000011",
										})}
										text={tilesValues.in30Days.total.length === tilesValues.in30Days.toBeHandled.length ? "0" : (tilesValues.in30Days.total.length - tilesValues.in30Days.toBeHandled.length).toString()}
									/>
								</div>
								<div className="media-body my-auto text-truncate">
									<h3 className="h5 fs-xl-auto fs-hd-root o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">À envoyer sous 30 jours</h3>
									<p className="h3 text-dark font-weight-bolder lh-solid mb-0">{tilesValues.in30Days.toBeHandled.length === 0 ? "Fait" : tilesValues.in30Days.toBeHandled.length}</p>
								</div>
							</div>
						</div>
						<div className="block">
							<div className="media">
								<div className="media-progress mr-3">
									<CircularProgressbar
										value={tilesValues.in6Months.total.length === tilesValues.in6Months.toBeHandled.length ? 0 : (tilesValues.in6Months.total.length - tilesValues.in6Months.toBeHandled.length) / tilesValues.in6Months.total.length}
										minValue={0}
										maxValue={1}
										background={true}
										styles={buildStyles({
											backgroundColor: "#00000011",
										})}
										text={tilesValues.in6Months.total.length === tilesValues.in6Months.toBeHandled.length ? "0" : (tilesValues.in6Months.total.length - tilesValues.in6Months.toBeHandled.length).toString()}
									/>
								</div>
								<div className="media-body my-auto text-truncate">
									<h3 className="h5 fs-xl-auto fs-hd-root o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">À envoyer sous 6 mois</h3>
									<p className="h3 text-dark font-weight-bolder lh-solid mb-0">{tilesValues.in6Months.toBeHandled.length === 0 ? "Fait" : tilesValues.in6Months.toBeHandled.length}</p>
								</div>
							</div>
						</div>
						<div className="block">
							<svg style={{ height: 0, position: "absolute" }}>
								<defs>
									<linearGradient id={"prime"} gradientTransform={`rotate(${90})`}>
										<stop offset="0%" stopColor={"#7c3761"} />
										<stop offset="100%" stopColor={"#4771a5"} />
									</linearGradient>
									<linearGradient id={"idCSS"} gradientTransform={`rotate(${90})`}>
										<stop offset="0%" stopColor={"#64CAB0"} />
										<stop offset="100%" stopColor={"#00BCFF"} />
									</linearGradient>
								</defs>
							</svg>
							<div className="media">
								<div className="media-progress mr-3" id="prime">
									<CircularProgressbar
										value={servicesToHandle === servicesTotal ? 0 : (servicesTotal - servicesToHandle) / servicesTotal}
										minValue={0}
										maxValue={1}
										background={true}
										styles={buildStyles({
											// Customize the text
											textColor: "#995D81",
											text: {
												opacity: "1",
											},
											pathColor: "url('#prime')",
											backgroundColor: "#995D8120",
										})}
										text={servicesToHandle === servicesTotal ? "0" : (servicesTotal - servicesToHandle).toString()}
									/>
								</div>
								<div className="media-body my-auto text-truncate">
									<h3 className="h5 fs-xl-auto fs-hd-aux o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">Courriers à valider</h3>
									<p className="h3 text-dark font-weight-bolder lh-solid mb-0">{servicesToHandle}</p>
								</div>
							</div>
						</div>
					</div>
				</header>
			</div>
			<div className="auto-view py-3 pb-lg-0">
				<div className="container-fluid">
					<section className="block mb-4">
						<div className="grid grid-1 grid-md-3 align-items-center mt-2">
							{deceasedUser.hasDocumentSending ? (
								<h2 className="h5 lh-copy text-uppercase font-weight-bolder my-auto grid-column-2">valider les documents nécessaires pour que nous puissions les envoyer :</h2>
							) : (
								<h2 className="h5 lh-copy text-uppercase font-weight-bolder my-auto grid-column-2">valider les documents nécessaires pour pouvoir les télécharger :</h2>
							)}
						</div>
						<nav className="navbar navbar-expand-sm navbar-light px-0 my-2">
							<button className="btn btn-icon alert-secondary navbar-toggler border-0 mb-2 rounded-max py-2 o-80 o-100--hover" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
								<span className="text-secondary eva eva-funnel-outline my-auto lh-1 fs-4"></span>
								<span className="h6 my-auto o-70 mx-2">Filtre</span>
							</button>
							<div className="nav navbar-inline navbar-collapse collapse" id="navbarNav">
								<form className="form-inline mx-auto">
									<div className="my-1 input-group btn-dim rounded-max mr-2">
										<input type="text" className="form-control bg-none rounded-inherit border-none no-focus shadow-none" placeholder="Recherche" aria-label="Recherche" onChange={(e) => setSearchFilter(e.target.value)} />
										<div className="input-group-prepend rounded-inherit">
											<button type="button" className="input-group-text btn btn-icon bg-dim border-left-0 border-none rounded-inherit m-1 w-4">
												<i className="eva eva-search-outline align-middle fs-root lh-0"></i>
											</button>
										</div>
									</div>
									<Link to={`/facilita/${userId}/declarer/step1`} type="button" className="btn btn-white-info rounded-max p-0 mr-2">
										<p className="form-control my-auto small">Modifications informations / Aides et allocations</p>
										<div className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4">
											<i className="eva eva-plus-outline align-middle fs-root lh-xs"></i>
										</div>
									</Link>
									<div className="divider-vertical mx-3"></div>
									<button type="button" className="btn btn-white-info rounded-max p-0 mr-2" data-toggle="modal" data-target="#servicesEdit">
										<p className="form-control my-auto small">Ajouter plus de services</p>
										<div className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4">
											<i className="eva eva-plus-outline align-middle fs-root lh-xs"></i>
										</div>
									</button>
								</form>
							</div>
						</nav>
						<section className="block mb-4">
							<div className="flex-row align-items-center mb-0">
								<h2 className="h6 text-uppercase text-secondary font-weight-bolder my-auto">À envoyer sous 7 jours: </h2>
							</div>
							<form className="grid grid-sm-min grid-lg-tight grid-lg-4 grid-xl-demarche py-sm">
								{servicesToDisplay
									.filter((s) => new Date(s.sendingLimitDate) <= dateIn7Days)
									.map((s, index) => {
										return <DashboardCard userService={s} index={index} key={"card_" + s.title} setSelectedService={setSelectedService} userLetters={userLetters} isLoadingLetters={isLoadingLetters} hasDocumentSending={deceasedUser.hasDocumentSending} />;
									})}
							</form>
						</section>
						<section className="block mb-4">
							<div className="flex-row align-items-center mb-0">
								<h2 className="h6 text-uppercase text-secondary font-weight-bolder my-auto">À envoyer sous 30 jours: </h2>
							</div>
							<form className="grid grid-sm-min grid-lg-tight grid-lg-4 grid-xl-demarche py-sm">
								{servicesToDisplay
									.filter((s) => new Date(s.sendingLimitDate) <= dateIn30Days && new Date(s.sendingLimitDate) > dateIn7Days)
									.map((s, index) => {
										return <DashboardCard userService={s} index={index} key={"card_" + s.title} setSelectedService={setSelectedService} userLetters={userLetters} isLoadingLetters={isLoadingLetters} hasDocumentSending={deceasedUser.hasDocumentSending} />;
									})}
							</form>
						</section>
						<section className="block mb-4">
							<div className="flex-row align-items-center mb-0">
								<h2 className="h6 text-uppercase text-secondary font-weight-bolder my-auto">À envoyer sous 6 mois: </h2>
							</div>
							<form className="grid grid-sm-min grid-lg-tight grid-lg-4 grid-xl-demarche py-sm">
								{servicesToDisplay
									.filter((s) => new Date(s.sendingLimitDate) <= dateIn6Months && new Date(s.sendingLimitDate) > dateIn30Days)
									.map((s, index) => {
										return <DashboardCard userService={s} index={index} key={"card_" + s.title} setSelectedService={setSelectedService} userLetters={userLetters} isLoadingLetters={isLoadingLetters} hasDocumentSending={deceasedUser.hasDocumentSending} />;
									})}
							</form>
						</section>
					</section>
					<ModalValidation
						service={selectedService}
						userLetters={userLetters}
						serviceDatas={serviceDatas}
						files={files}
						userId={userId}
						isLoading={isLoading}
						setIsLoadingLetter={setIsLoadingLetter}
						isLoadingLetters={isLoadingLetters}
						declaringUserId={declaringUserId}
						currentlyConnectedUserId={currentlyConnectedUserId}
						hasDocumentSending={deceasedUser.hasDocumentSending}
					/>
					<ModalCommencer text={popupText.text} />
					<ServicesEdit activeUserConnections={connectionTypes} serviceDatas={serviceDatas} isLoading={isLoading} userId={userId} displayComments={false} disableModifications={true} generateLetters={generateLetters} />
				</div>
			</div>
		</article>
	);
};